export function VisaLogo({ size = 24 }) {
  return <svg viewBox="0 0 48 32" width={size * 1.5} height={size} fill="none"><rect width="48" height="32" rx="4" fill="#1A1F71"/><path d="M19.5 21.5h-3.2l2-12.3h3.2l-2 12.3zm13.5-12c-.6-.3-1.6-.5-2.8-.5-3.1 0-5.3 1.6-5.3 4 0 1.7 1.6 2.7 2.8 3.3 1.2.6 1.6 1 1.6 1.5 0 .8-1 1.2-1.9 1.2-1.2 0-1.9-.2-2.9-.6l-.4-.2-.4 2.6c.7.3 2.1.6 3.5.6 3.3 0 5.4-1.6 5.4-4.1 0-1.4-.8-2.4-2.7-3.3-1.1-.6-1.8-.9-1.8-1.5 0-.5.6-1 1.8-1 1 0 1.8.2 2.4.5l.3.1.4-2.6zM38 9.2h-2.4c-.7 0-1.3.2-1.6 1l-4.6 10.8h3.3l.7-1.8h4l.4 1.8H41L38 9.2zm-3.8 8l1.7-4.5.9 4.5h-2.6zM15.8 9.2l-3 8.4-.3-1.6c-.6-1.9-2.3-3.9-4.3-4.9l2.8 10.4h3.3l4.9-12.3h-3.4z" fill="white"/><path d="M10.5 9.2H5.1l-.1.3c3.9 1 6.5 3.4 7.6 6.3l-1.1-5.5c-.2-.8-.8-1-.1-.1z" fill="#F9A51A"/></svg>;
}

export function MastercardLogo({ size = 24 }) {
  return <svg viewBox="0 0 48 32" width={size * 1.5} height={size} fill="none"><rect width="48" height="32" rx="4" fill="#252525"/><circle cx="19" cy="16" r="9" fill="#EB001B"/><circle cx="29" cy="16" r="9" fill="#F79E1B"/><path d="M24 9.3a9 9 0 013 6.7 9 9 0 01-3 6.7 9 9 0 01-3-6.7 9 9 0 013-6.7z" fill="#FF5F00"/></svg>;
}

export function ApplePayLogo() {
  return <img src="/logos/apple-pay.png" alt="Apple Pay" className="h-7 object-contain" />;
}

export function GooglePayLogo() {
  return <img src="/logos/google-pay.png" alt="Google Pay" className="h-7 object-contain" />;
}

export function InteracLogo() {
  return <img src="/logos/interac.jpg" alt="Interac" className="h-8 rounded object-contain" />;
}

export function SezzleLogo() {
  return <img src="/logos/sezzle.jpg" alt="Sezzle" className="h-8 rounded object-contain" />;
}
